import Vue from 'vue'
import EventBus from 'chimera/all/plugins/eventbus'

export default () => {
  Vue.use(EventBus)
}
